<template>
	<div class="data-row flex-1 flex-centerize">
		<AppGroupAvatar :group="group" :size="size" :avatarColor="avatarColor" />
		<div class="row-details flex-1 mr-1 ml-4">
			<div class="row-title">{{ group.name }}</div>
			<div v-if="isShowNamePath && groupNamePath" class="font-size-xs path">{{ groupNamePath }}</div>
			<div v-else class="font-size-xs path">{{ usersCount }}</div>
		</div>
		<slot />
		<ProjectRoleSelector :isReadOnly="isReadOnly" :projectId="projectId" :role="role" :group="group" />
	</div>
</template>

<script>
import { pluralize } from '@/utils/language-service';

import { mapGetters } from 'vuex';
import { getProject } from '@/store/modules/projects/getters';
import { groupPathItems } from '@/store/modules/accountGroups/getters';
import ProjectRoleSelector from './ProjectRoleSelector.vue';
export default {
	name: 'GroupDataRow',
	components: { ProjectRoleSelector },
	props: {
		projectId: { type: Number },
		group: { type: Object, required: true },
		size: { type: Number, default: 40 },
		groupData: { type: Object },
		isShowNamePath: { type: Boolean },
		isReadOnly: { type: Boolean },
		avatarColor: { type: String },
	},
	computed: {
		...mapGetters([getProject.fullPath, groupPathItems.fullPath]),
		project() {
			return this[getProject.fullPath];
		},
		groupNamePath() {
			if (!this.group) {
				return;
			}
			const pathItems = this[groupPathItems.fullPath](this.group);
			if (pathItems.length === 1) {
				return;
			}

			return `${pathItems.map((g) => g.name).join(' > ')}`;
		},
		usersCount() {
			const count = this.group?.all_users?.length || 0;
			return pluralize('user', count, true);
		},
		role() {
			return this.groupData?.role;
		},
	},
};
</script>

<style scoped lang="scss">
@import './data-row.scss';
</style>

<style scoped lang="scss">
.data-row {
	.row-details {
		.path {
			font-weight: 300;
			opacity: 0.5;
		}
	}
}
</style>
